import { __exportAll } from "../../_virtual/_rolldown/runtime.js";

//#region src/types/plugins/SharePlugin.ts
var SharePlugin_exports = /* @__PURE__ */ __exportAll({});

//#endregion
export { SharePlugin_exports };
//# sourceMappingURL=SharePlugin.js.map